<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="disabledSave") {{ $t('Common.save') }}

    v-row(v-if="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5
          app-full-entity(v-if="!loading", :entity="entity")
</template>

<script>
import assign from 'lodash/assign'
import axios from 'axios'
import EntityMixin from '@/mixins'
import { removeFirstCriteriaLogicalOperator } from '@@/helpers'

export default {
  mixins: [EntityMixin],
  name: 'Trigger',
  data: () => ({
    disabledSave: false,
    loading: true,
    errors: {}
  }),

  computed: {
    entityName () {
      return 'Trigger'
    },
    entity () {
      return this.$findEntity('Trigger')
    },
    uid () {
      return this.$route.params.item
    },
    loadExtraData() {
      return this.$isExtraDateable(this.entity) ? '?load[]=ExtraData' : ''
    }
  },

  methods: {
    update (instance, entity) {
      this.instance = assign({}, this.instance, entity ? { [entity]: instance } : instance)
    },

    async save () {
      try {
        this.disabledSave = true;
        if (this.instance.businessScope == null || this.instance.businessScopeId === null) this.instance.businessScopeId = this.$getBusinessScopeId();
        removeFirstCriteriaLogicalOperator(this.instance.criterias);
        var response = (await axios.post('entity/graph', this.instance))
        this.instance = response.data
        this.$router.push({
          name: 'entities.index',
          params: { entity: this.entity.name }
        })
      } catch (error) {
        this.errors = error.response.data.errors
        this.$store.commit('SET_ERRORS', this.errors)
        this.$store.commit('SET_ERROR_MODAL', true)
      } finally {
        this.disabledSave = false;
      }
    },

    async load () {
      if (this.uid) {
        try {
          this.instance = (await axios.get(`${this.entity.name}/${this.uid}${this.loadExtraData}`, {
            _Entity: this.entity.name,
            uid: this.uid,
            params: {
              load: ["triggerActions","triggerActions.Action","triggerActions.ActionTemplate"],
            },
          })).data
          this.instance.entityState = 3
          this.$store.commit('SET_INSTANCE', this.instance)

        } catch (error) {
          console.error(error)
        }
      }
      else{
        this.instance = {
          ...this.instance,
          triggerActions: []
        }
        this.instance.triggerActions = [{__id: this.$uid() ,entityState: 4, _Entity: 'TriggerActions' }];
      }
      this.loading = false
    }
  },

  created () {
    this.$store.commit('SET_INSTANCE', null)
  },

  async mounted () {
    await this.load()
  }
}
</script>
